import Vue from 'vue';

// FILTERS

Vue.filter('capitalize', (value) => {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('date', (value) => {
	if (!value) return ''
	if(value.length > 10) {
		return moment(value).format('DD/MM/YYYY HH:mm')
	} else {
		return moment(value).format('L')
	}
})

Vue.filter('datetime', (value) => {
	if (!value) return ''
	value = value.toString()
	return moment(value).format('DD/MM/YYYY HH:mm')
})

Vue.filter('duration', (value) => {
	if (!value) return '00:00'
	let h = value / 60 | 0,
	m = value % 60 | 0
	let result = ''
	if(h <= 9) {
		result = '0' + Math.round(h).toString() + ':' 
	} else {
		result = Math.round(h).toString() + ':'
	}
	if(m <= 9) {
		result = result +  '0' + m.toString()
	} else {
		result = result + m.toString()
	}

	return result
})

Vue.filter('currency', (value, decimails = 5, currency = 'EUR') => {
	if (value === '' || typeof value === 'undefined') return ''
	if(!isNumber(value)){ 
		try {
			value = JSON.parse(value)			
		} catch (error) {
			return ''
		}
	}
	if(!isNumber(value)) return ''
	return new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: currency,
		maximumFractionDigits: decimails,
		currencyDisplay: 'narrowSymbol'		
	}).format(value)
})

Vue.filter('balance', (value, decimails = 1) => {
	if (value === '' || typeof value === 'undefined') return ''
	// if(value < 99999) {
	// 	if(!isNumber(value)) return ''
	// 	return new Intl.NumberFormat('it-IT', {
	// 		style: 'currency',
	// 		currency: 'EUR',
	// 		maximumFractionDigits: decimails
	// 	}).format(value)		
	// } else {
		const lookup = [
		  { value: 1, symbol: "" },
		  { value: 1e3, symbol: "K" },
		  { value: 1e6, symbol: "M" },
		  { value: 1e9, symbol: "G" },
		  { value: 1e12, symbol: "T" },
		  { value: 1e15, symbol: "P" },
		  { value: 1e18, symbol: "E" }
		]
		const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
		var item = lookup.slice().reverse().find((item) => {
		  return value >= item.value
		})
		return item ? (value / item.value).toFixed(decimails).replace(rx, "$1") + item.symbol : "0"
	// }
	  
})

Vue.filter('byte', function (bytes, decimals, kib) {
	kib = kib || false
	if (bytes === 0) return '0 Bytes'
	if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) return 'Not an number'
	const k = kib ? 1024 : 1000
	const dm = decimals || 2
	const sizes = kib ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'] : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
})

Vue.filter('fileName', (name, ext) => {
	if (!name) return ''
	if (!ext) return name
	return name.endsWith('.' + ext) ? name : name + '.' + ext
})

function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
}